import { render, staticRenderFns } from "./MoleculeIconListWithTexts.vue?vue&type=template&id=5affc228&"
import script from "./MoleculeIconListWithTexts.vue?vue&type=script&lang=js&"
export * from "./MoleculeIconListWithTexts.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeIconListWithTexts.vue?vue&type=style&index=0&id=5affc228&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIconAndText: require('/app/components/atoms/common/AtomIconAndText.vue').default})
